import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";
import Layout from "../components/layout/Layout";
import ErrorBoundary from "../components/common/ErrorBoundary/ErrorBoundary";

const AppComponent = lazy(() => import("../App"));
const DryDockComponent = lazy(() => import("../components/drydock/DryDock"));

export const routeConfig: RouteObject[] = [
  {
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "*",
        element: <AppComponent title="Canvas Excel Add-in" isOfficeInitialized />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/drydock",
        element: <DryDockComponent />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
];

const getRoutes = (): RouteObject[] => {
  return routeConfig;
};

export default getRoutes;
